import React, {createContext, useReducer, useContext} from 'react'

const DrawingStateContext = createContext()
const DrawingDispatchContext = createContext()

const initialState = {
  marker: {
    show: false,
    url: null,
    elementId: null
  },
  highlights: {
    assetType: 'rm',
    highlights: {},
    show: false,
    selectable: false,
    selector: false,
    reset: false
  },
  status: {
    hasSvgData: false,
    blId: '',
    flId: ''
  }
}

const drawingReducer = (state, action) => {
  switch (action.type) {
    case 'setDrawingShowMarker':
      return {
        ...state,
        marker: {
          ...action.payload
        }
      }

    case 'setDrawingHighlights':
      return {
        ...state,
        highlights: {
          ...action.payload
        }
      }

    case 'setStatus':
      return {
        ...state,
        status: action.payload
      }

    default: {
      throw new Error(`Unhandled action type: ' ${action.type}`)
    }
  }
}

const setDrawingShowMarker = ({dispatch, show, elementId = '', url = ''}) => {
  dispatch({type: 'setDrawingShowMarker', payload: {show, elementId, url}})
}

const setDrawingHighlights = ({
  dispatch,
  assetType,
  highlights,
  show,
  selectable = false,
  selector = false,
  reset = false
}) => {
  dispatch({
    type: 'setDrawingHighlights',
    payload: {assetType, highlights, show, selectable, selector, reset}
  })
}

const setDrawingStatus = ({
  dispatch,
  hasSvgData,
  blId,
  flId
}) => {
  dispatch({
    type: 'setStatus',
    payload: {hasSvgData, blId, flId}
  })
}

const DrawingProvider = ({children}) => {
  const [state, dispatch] = useReducer(drawingReducer, initialState)

  return (
    <DrawingStateContext.Provider value={state}>
      <DrawingDispatchContext.Provider value={dispatch}>
        {children}
      </DrawingDispatchContext.Provider>
    </DrawingStateContext.Provider>
  )
}

const useDrawingState = () => {
  const context = useContext(DrawingStateContext)

  if (context === undefined) {
    throw new Error('useDrawingState must be used within a DrawingProvider')
  }
  return context
}

const useDrawingDispatch = () => {
  const context = useContext(DrawingDispatchContext)

  if (context === undefined) {
    throw new Error('useDrawingDispatch must be used within a DrawingProvider')
  }
  return context
}

export {
  DrawingProvider,
  useDrawingState,
  useDrawingDispatch,
  setDrawingShowMarker,
  setDrawingHighlights,
  setDrawingStatus
}
